import HeroImageFilter from './HeroImageFilter'


export default HeroImageFilter
